import TrackingProjectsModel from './TrackingProjectsModel'
import TrackingProjectsController from './TrackingProjectsController'
import Splash from '../../../components/Splash'
import * as React from 'react'
import { Onboarding } from '../../../components/Onboarding/Onboarding'
import { ONBOARDING_TRACKING_PROJECT } from '../../../utils/Constants'
import { Box, Button, Chip, CircularProgress, Grid2, TextField, Tooltip, Typography } from '@mui/material'
import PaperItem from '../../../components/Essential/PaperItem'
import TableComponent from '../../../components/TableComponent'
import * as CONSTANTS from '../../../utils/TableColumnsConstants'
import { Trans, useTranslation } from 'react-i18next'
import PersonAddIcon from '@mui/icons-material/PersonAdd'
import WorkIcon from '@mui/icons-material/Work';
import './TrackingProjects.scss'
import TrackingLimitError from '../errors/TrackingLimitError'
import AddIcon from '@mui/icons-material/Add';

const TrackingProjectsView = () => {
  const { t } = useTranslation()

  const model = TrackingProjectsModel()
  const controller = TrackingProjectsController(model)

  if(model.projectsLoaded!==true) {
    return <Splash />
  }

  return (
    <>
      {/* Check if projects exist and are empty */}
      {model.projects==null || (model.projects && model.projects.length === 0) ? (
          <Onboarding data={ONBOARDING_TRACKING_PROJECT}
                      onClick={() => controller.handleOnboardingAddProjectClick(model.onBoardingInputValue)}
                      showInput setOnBoardingInputValue={model.setOnBoardingInputValue}
                      loading={model.isLoading.projects}
          />
        ) :
        <Grid2 container spacing={2} className='container-analysis trackingProjects'>

          {/* if limit exceeded, show an error message */}
          {model.limitExceeded && (
            <TrackingLimitError title='trackingProjectLimitTitle' description='trackingProjectLimitDescription' />
          )}

          <Grid2 size={{ xs: 12 }} sx={{ alignItems: 'end', display: 'flex', justifyContent: 'end' }} >
            <PaperItem className='boxShadow' sx={{ p: 3, height: '100%', width: '100%' }}>
              <Grid2 container justifyContent={'space-between'} alignItems={'center'} sx={{ mb: -2, mt: -2, display: 'flex', justifyContent: 'space-between' }} >
                <Grid2 className='examples'><Trans i18nKey={'addFirstTrackingProjectTopDescription2'} components={{ strong: <strong /> }} /></Grid2>
                <Grid2>
                  <Box mb={0} display="flex" justifyContent="flex-end" alignItems="center" gap={2}>
                    <Tooltip title={t('usedProjects', { count: model.projects.length, limit: model.limit })} arrow followCursor>
                      <Chip
                        icon={<WorkIcon />}
                        label={`${model.projects.length || 0} / ${model.limit} ${t('projects')}`}
                        variant="filled"
                        color={model.limitExceeded ? 'error' : 'warning'}
                        sx={{ mr: 2, fontWeight: 700, textTransform: 'capitalize', px: 1.5 }}
                      />
                    </Tooltip>

                      <TextField onChange={(e) => model.setInputNewProject(e.currentTarget.value)}
                                 variant="standard" autoComplete="off" slotProps={{ input: { disableUnderline: true } }} sx={{ height: '30px', width: '400px'}}
                                 placeholder={t('add_projects')}
                      ></TextField>
                    <Tooltip title={t('add_projects')} arrow followCursor>
                      <Button sx={{ height: '30px', width: '200px'}} disabled={model.isLoading.addAccount} variant="contained" onClick={() => controller.handleOnboardingAddProjectClick(model.inputNewProject)} >
                        <AddIcon />
                        {model.isLoading.addAccount ? (
                          <CircularProgress size={15} sx={{ bgcolor: 'transparent', color: 'white' }} />
                        ) : (
                          t('project')
                        )}
                      </Button>
                    </Tooltip>
                  </Box>

                </Grid2>
              </Grid2>

            </PaperItem>
          </Grid2>

          <Grid2 size={{ xs: 12 }}>
            <PaperItem className='boxShadow' sx={{ p: 3, height: '100%' }}>
              <TableComponent
                className='fullHeight'
                rowBuffer={0}
                columnBuffer={0}
                getRowHeight={() => 'auto'}
                rows={model.projects}
                loading={model.isLoading.projects}
                columns={CONSTANTS.TRACKING_PROJECTS(t, { model: model, onDelete: controller.handleOnDeleteClick })}
                paginationMode='client'
                sortingMode='client'
                hideFooter={model.projects.length<11}
              />
            </PaperItem>
          </Grid2>


        </Grid2>
      }

    </>
    )
}

export default TrackingProjectsView;